import CoutionIconWebp from '../img/caution-icon.webp';
import CoutionIcon from '../img/caution-icon.png';

import './Caution.css';

export default function Caution() {
    return (
        <div className="Caution">
            <div className="Caution__icon--pc">
                <picture>
                    <source type="image/webp" srcSet={CoutionIconWebp} />
                    <img src={CoutionIcon} alt="caution icon" />
                </picture>
            </div>
            <div>
                <div className="Caution__titleContaier">
                    <div className="Caution__icon--sp">
                        <picture>
                            <source type="image/webp" srcSet={CoutionIconWebp} />
                            <img src={CoutionIcon} alt="caution icon" />
                        </picture>
                    </div>
                    <h3 className="Caution__h3">CAUTION</h3>
                </div>
                <p className="Caution__p">
                    While Revving(Staking) your NFTs, You CANNOT sell them on marketplace even if there is a buyer.
                    If you want to sell, please DO NOT Rev (Stake)
                    If you want to Rev(Stake) and earn RPM, DO NOT list on marketplace.
                    We reserve the right to un-REV your BŌSŌ TOKYO NFT as a matter of course when it is listed for sale.<br />
                    <br />
                </p>
                <p className="Caution__p--red">
                    To download a 3D model, you must have accumulated more than 100,000 RPM and have a BOSO TOKYO NFT revved (staked)
                </p>
            </div>
        </div>
    )
}